import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from 'react';
import { FormattedInput } from '../FormattedInput/FormattedInput';

/**
 * `InputZIP` proactively eliminates errors by restricting data and input width to align with
 * user expectations and business requirements.
 */
export var InputZIP = function InputZIP(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'ZIP Code' : _ref$label,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    label: label
  }, otherProps, {
    // We force a smaller, fixed width to maintain consistency
    small: true,
    format: "#####" // Used to restrict what's available
    // to mobile users via keyboard. We
    // don't use the pattern attribute
    // as that will trigger validation in some
    // browsers like Firefox.
    ,
    type: "tel"
  }));
};